export default "__VITE_ASSET__d493be54__"